// pages/Insights.js
import React from 'react';
import { ContentLayout, PageContainer } from '../components/layout/Layout';
import { useTranslations } from '../hooks/useTranslations';
import AppointmentsTrendDashboard from '../components/charts/AppointmentsTrendDashboard';
import AppointmentsMonthComparison from '../components/charts/AppointmentsMonthComparison';
import ServiceDistributionDashboard from '../components/charts/ServiceDistributionChartComponent';

// Update Sidebar.js - Add insights to menuItems array:
export function Insights({ onNavigate }) {
  const t = useTranslations();

  return (
    <ContentLayout
      currentPage="insights"
      onNavigate={onNavigate}
      title={t.insights}
      description={t.viewInsightsAndAnalytics}
    >
      <PageContainer>
        <div className="space-y-8">
          <div className="">
            <AppointmentsTrendDashboard />
          </div>
          <div className="">
            <AppointmentsMonthComparison />
          </div>
          <div className="">
            <ServiceDistributionDashboard />
          </div>
        </div>
      </PageContainer>
    </ContentLayout>
  );
}